import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './AdvisorPanel_Home.scss';
import { Button, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { PanelKey_Home } from '@app/advisor-v5-shared';
import { Component_RefreshEncounter } from '../../components/welcome/Component_RefreshEncounter/Component_RefreshEncounter.js';
import { Component_HomeTitle } from '../../components/home-panel/home-title/Component_HomeTitle.js';
import { Component_UtilitiesMenu } from '../../components/home-panel/Component_UtilitiesMenu/Component_UtilitiesMenu.js';
import { Component_TimeSinceTriageV2 } from '../../components/home-panel/v2/time-since-triage/Component_TimeSinceTriageV2.js';
import { Component_CatchUp_Vitals } from '../../components/catch-up/vitals/Component_CatchUp_Vitals.js';
import { Component_HomeScores } from '../../components/home-panel/home-scores/Component_HomeScores.js';
import { Component_HPI } from '../../components/hpi/Component_HPI/Component_HPI.js';
import { Component_Inbox } from '../../components/inbox/Component_Inbox/Component_Inbox.js';
import { Inbox_Filtering } from '../../../_enum/inbox-filter/Inbox_Filtering.js';
import { Component_WizardIcon } from '../../components/advisor-wizard/Component_WizardIcon/Component_WizardIcon.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
export class AdvisorPanel_Home extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_Home,
    };
    //######################### Life Cycle #########################
    __onReadOnlyChanged() {
        this.forceUpdate();
    }
    //######################### Logic #########################
    refreshHPI = async () => {
        if (ModuleFE_EMInterface.isPostDisposition() || ModuleFE_EMInterface.isReadonly())
            return;
        return ModuleFE_EMInterface.updateEncounterApis.refreshHPI();
    };
    //######################### Render #########################
    renderFooter = undefined;
    renderSubHeader = undefined;
    renderContent = () => undefined;
    renderHeader_Title = () => {
        return _jsx(Component_HomeTitle, {});
    };
    renderHeader_Tail = () => {
        return _jsxs(_Fragment, { children: [_jsx(Component_TimeSinceTriageV2, {}), _jsx(Component_RefreshEncounter, {}), _jsx(Component_UtilitiesMenu, {})] });
    };
    _renderContent(scrollRef) {
        return _jsxs(LL_V_L, { className: 'advisor-panel__content', children: [this.render_HPI(), _jsx(Component_CatchUp_Vitals, {}), _jsx(Component_HomeScores, {}), this.render_Inbox()] });
    }
    render_HPI = () => {
        const readonly = ModuleFE_EMInterface.isReadonly();
        return _jsxs(LL_V_L, { className: 'section-wrapper', children: [_jsxs(LL_H_C, { className: 'section-header', children: [_jsx("div", { className: 'section-title', children: "Chief Complaint & HPI" }), _jsxs(LL_H_C, { className: 'section-header-tail', children: [!readonly && _jsx(Button, { variant: 'header-button', onClick: this.refreshHPI, children: _jsx(ICONS.sync.component, {}) }), _jsx(Component_WizardIcon, { tooltipContent: 'Edit HPI', wizardFilter: w => w.config.isHpi })] })] }), _jsx(Component_HPI, {})] });
    };
    render_Inbox = () => {
        return _jsxs(LL_V_L, { className: 'section-wrapper', children: [_jsxs(LL_H_C, { className: 'section-header', children: [_jsx("div", { className: 'section-title', children: "Inbox" }), _jsx(LL_H_C, { className: 'section-header-tail', children: _jsx(Inbox_Filtering, { variant: 'concise' }) })] }), _jsx(Component_Inbox, {})] });
    };
}
//# sourceMappingURL=AdvisorPanel_Home.js.map